export default "__VITE_ASSET__$2QDk9zt__";